<template>
    <footer class="bd-footer text-muted docs-border">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div>© Zavod Dobra pot | <a href="https://docs.google.com/forms/d/e/1FAIpQLSc8LQjAExII8JmiKigyYTG72KDwdcu-msAQ-TH44MZ_iIGDKQ/viewform?usp=sf_link" target="_blank">Prijava napake v Adi aplikaciji</a></div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'Footer',
    data: function () {
      return {}
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue